import { useEffect, useState, useMemo } from "react";
import LinkHandler from "./LinkHandler.tsx";
import { useFlowStore } from "../../store/FlowStateStore.ts";
import axios from "axios";
import { CanvasNode, CanvasNodeData } from "../../models/CanvasNode.ts";
import DynamicText from "./DynamicText.tsx";
import { Environment as environment } from "../../environment.ts";

interface Attribute {
    attributeId: string;
    attributeName: string;
    businessId: string;
}

const Condition: React.FC<any> = (data) => {
    const { nodes, setNodes, edges, businessId } = useFlowStore();
    const [attributes, setAttributes] = useState<Attribute[]>([]);
    const [attribute, setAttribute] = useState<string>("");
    const [conditionType, setConditionType] = useState<string>("EQUAL");
    const [attributeValue, setAttributeValue] = useState<string>("");

    const savedData = useMemo(() => {
        const node = nodes.find((n) => n.data.id === data.nodeId);
        if (node) {
            const content = (node.data as CanvasNodeData).content.find((c) => c.id === data.subNodeId);
            if (content?.data) {
                return content.data as any;
            }
        }
        return null;
    }, []);

    const CONDITIONS = useMemo(
        () => [
            { id: savedData?.trueNode || crypto.randomUUID(), text: "True", color: "green" },
            { id: savedData?.falseNode || crypto.randomUUID(), text: "False", color: "tomato" },
        ],
        []
    );

    useEffect(() => {
        if (savedData) {
            setAttribute(savedData.attribute || "");
            setConditionType(savedData.condition || "EQUAL");
            setAttributeValue(savedData.attributeValue || "");
        }
    }, []);

    useEffect(() => {

        const updatedNodes = nodes.map((node) => {
            if (node.data.id == data.nodeId) {
                return {
                    ...node,
                    data: {
                        ...node.data,
                        content: [...(node.data as CanvasNodeData).content.map((nodeContent) => {
                            if (nodeContent.id == data.subNodeId) {
                                return {
                                    ...nodeContent,
                                    data: {
                                        attribute: attribute,
                                        condition: conditionType,
                                        attributeValue: attributeValue,
                                        falseNode: CONDITIONS[1].id,
                                        trueNode: CONDITIONS[0].id
                                    }
                                }
                            }
                            return nodeContent
                        })]
                    }
                }
            }
            return node;
        });
        setNodes([...(updatedNodes as CanvasNode[])]);
    }, [conditionType, attribute, attributeValue, edges]);

    const getAllAtributes = () => {
        const payload = {
            businessId: businessId,
            page: 0,
            size: 100,
        };
        axios
            .put(`${environment.baseUrl}/fetch/attribute`, payload)
            .then((response) => {
                setAttributes(response.data.data.data);
                if (!savedData?.attribute) {
                    setAttribute(response.data.data.data[0].attributeName);
                }
            })
            .catch(() => { });
    };

    useEffect(() => {
        getAllAtributes();
    }, []);

    return (
        <div className="node-body">
            <div>
                <div className="flex flex-row justify-between">
                    <span className="font-label">Select Condition</span>
                </div>
                <select
                    value={conditionType}
                    onChange={(event) => setConditionType(event.target.value)}
                >
                    <option value="EQUAL">Equals</option>
                    <option value="NOT_EQUAL">Not equals</option>
                    <option value="CONTAINS">Contains</option>
                    <option value="GREATER_THAN">Greater than</option>
                    <option value="LESS_THAN">Less than</option>
                    <option value="EXISTS">Exists</option>
                </select>
            </div>

            <div>
                <div className="flex flex-row justify-between">
                    <span className="font-label">Select Attribute</span>
                </div>
                <select
                    value={attribute}
                    onChange={(event) => setAttribute(event.target.value)}
                >
                    {attributes.map((attr) => (
                        <option key={attr.attributeId} value={attr.attributeName}>
                            {attr.attributeName}
                        </option>
                    ))}
                </select>
            </div>

            {conditionType !== "EXISTS" && <div>
                <span className="font-label">Value</span>
                <DynamicText
                    placeholder="Value to compare"
                    value={attributeValue}
                    setValue={(val) => setAttributeValue(val)}
                    maxLength={20}
                />
            </div>}

            {CONDITIONS.map((condition) => (
                <ConditionalRedirect
                    key={condition.id}
                    data={data}
                    placeholder={condition.text}
                    color={condition.color}
                    id={condition.id}
                />
            ))}
        </div>
    );
};

const ConditionalRedirect = ({ data, placeholder, color, id }) => {
    return (
        <div
            style={{
                position: "relative",
                border: `1px solid ${color}`,
                width: "100%",
                backgroundColor: "white",
                padding: "5px",
                borderRadius: "5px",
                marginTop: "5px",
            }}
        >
            <div style={{ textAlign: "center", color }}>{placeholder}</div>
            <LinkHandler idx={id} />
        </div>
    );
};

export default Condition;
